export var getConfigLibro = function getConfigLibro(state, libroId) {
  var configLibro = state.configLibros[libroId];

  if (!configLibro) {
    window.console.error("src/selectors getConfigLibro desconocido(" + libroId + ")");
    window.alert("src/selectors getConfigLibro desconocido(" + libroId + ")");
    return {};
  }

  return configLibro;
};
export var getIdByNum = function getIdByNum(state, num) {
  var configLibros = state.configLibros;

  for (var key in configLibros) {
    if (configLibros[key].num === Number(num)) {
      return key;
    }
  }
};
export var getNum = function getNum(state, libroId) {
  return getConfigLibro(state, libroId).num;
};
export var getPrimeraPagina = function getPrimeraPagina(state, libroId) {
  return getConfigLibro(state, libroId).primeraPaginaVisible;
};
export var getUltimaPagina = function getUltimaPagina(state, libroId) {
  return getConfigLibro(state, libroId).ultimaPaginaVisible;
};
export var getPosicionPrimeraPagina = function getPosicionPrimeraPagina(state, libroId) {
  return getConfigLibro(state, libroId).posicionPrimeraPagina;
};
export var getMultiplicadorBaja = function getMultiplicadorBaja(state, libroId) {
  var multiplicadorBaja = getConfigLibro(state, libroId).multiplicadorBaja || 1;
  return Number(multiplicadorBaja);
};
export var getConsolaLupaDefecto = function getConsolaLupaDefecto(state, libroId, ventanaId) {
  var configVentana = getConfigLibro(state, libroId)[ventanaId] || {};
  return configVentana.lupa;
};
export var getConsolaLupaSegunAncho = function getConsolaLupaSegunAncho(state, libroId, coordenadas, ventanaId) {
  var configLibro = getConfigLibro(state, libroId)[ventanaId] || {};

  if (coordenadas.substr(0, 4) === 'img,') {
    return false;
  }

  if (!configLibro.rangosLupaSegunAncho) {
    return false;
  }

  var lupa = false;
  var ancho = Number(coordenadas.split(',')[2]);

  if (coordenadas.split(':').length > 1) {
    ancho = contornoZonaPoligonal(coordenadas)[2];
  }

  for (var rango in configLibro.rangosLupaSegunAncho) {
    var valorMinimo = Number(rango.split('-')[0].split('(').join('').split('[').join(''));
    var valorMaximo = Number(rango.split('-')[1].split(')').join('').split(']').join(''));
    var condicionMin = rango.charAt(0) === '(' ? ancho > valorMinimo : ancho >= valorMinimo;
    var condicionMax = rango.charAt(rango.length - 1) === ')' ? ancho < valorMaximo : ancho <= valorMaximo;

    if (condicionMin && condicionMax) {
      lupa = configLibro.rangosLupaSegunAncho[rango];
    }
  }

  return lupa;
};

function contornoZonaPoligonal(coordenadas) {
  var xzpMin, xzpMax, yzpMin, yzpMax, ancho, alto;
  xzpMin = xzpMax = parseInt(coordenadas.split(":")[0].split(",")[0], 10);
  yzpMin = yzpMax = parseInt(coordenadas.split(":")[0].split(",")[1], 10);

  for (var cpk = 1; cpk < coordenadas.split(":").length; cpk++) {
    if (parseInt(coordenadas.split(":")[cpk].split(",")[0], 10) < xzpMin) {
      xzpMin = parseInt(coordenadas.split(":")[cpk].split(",")[0], 10);
    }

    if (parseInt(coordenadas.split(":")[cpk].split(",")[0], 10) > xzpMax) {
      xzpMax = parseInt(coordenadas.split(":")[cpk].split(",")[0], 10);
    }

    if (parseInt(coordenadas.split(":")[cpk].split(",")[1], 10) < yzpMin) {
      yzpMin = parseInt(coordenadas.split(":")[cpk].split(",")[1], 10);
    }

    if (parseInt(coordenadas.split(":")[cpk].split(",")[1], 10) > yzpMax) {
      yzpMax = parseInt(coordenadas.split(":")[cpk].split(",")[1], 10);
    }
  }

  ancho = xzpMax - xzpMin;
  alto = yzpMax - yzpMin;
  return [xzpMin, yzpMin, ancho, alto];
}

export var getDimensionesAlta = function getDimensionesAlta(state, libroId) {
  return getConfigLibro(state, libroId).dimensionesAlta;
};
export var getDimensionesBaja = function getDimensionesBaja(state, libroId) {
  return getConfigLibro(state, libroId).dimensionesBaja;
};
export var getBajaToAltaX = function getBajaToAltaX(state, libroId) {
  //const configLibro = getConfigLibro(state, libroId)
  var dimensionesBaja = getDimensionesBaja(state, libroId);
  var dimensionesAlta = getDimensionesAlta(state, libroId);
  var multiplicadorBaja = getMultiplicadorBaja(state, libroId);
  return function (num) {
    return Math.trunc(num * (dimensionesAlta.w / (dimensionesBaja.w * multiplicadorBaja)));
  };
};
export var getBajaToAltaY = function getBajaToAltaY(state, libroId) {
  var dimensionesBaja = getDimensionesBaja(state, libroId);
  var dimensionesAlta = getDimensionesAlta(state, libroId);
  var multiplicadorBaja = getMultiplicadorBaja(state, libroId);
  return function (num) {
    return Math.trunc(num * (dimensionesAlta.h / (dimensionesBaja.h * multiplicadorBaja)));
  };
};
export var getNumPaginaIzquierda = function getNumPaginaIzquierda(state, libroId, numPaginaRef) {
  var numPagina = numPaginaRef; // || getNumPagina(state, libroId);
  // const modo = getModo(state)

  var posicionPrimeraPagina = getPosicionPrimeraPagina(state, libroId); // if (modo === 'unaPagina') {
  //     return numPagina
  // }

  var esParPrimeraPagina = getPrimeraPagina(state, libroId) % 2 === 0;
  var esParNumPagina = numPagina % 2 === 0;

  if (posicionPrimeraPagina === 'izquierda') {
    if (esParPrimeraPagina === esParNumPagina) {
      return numPagina;
    }

    return numPagina - 1;
  }

  if (posicionPrimeraPagina === 'derecha') {
    if (esParPrimeraPagina === esParNumPagina) {
      return numPagina - 1;
    }

    return numPagina;
  }
};
export var getPaginasPorPantalla = function getPaginasPorPantalla(state, libroId) {
  return getConfigLibro(state, libroId).paginasPorPantalla || 2;
};